import Button from "../../../../Core/Button/Button";
import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import { useState } from 'react';
import GetIcon from "../../../../utils/Icon";

const EditItemModal = ({ show, onClose }) => {
  const [currentSerialInput, setCurrentSerialInput] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");



  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <h5 className="modal-title">Select Purchase Order</h5>
            <button type="button" className="btn-close" style={{ width: "5px", height: "5px", paddingLeft: "23px",fontSize:'12px' }} onClick={onClose}></button>
          </div>
          <div className="modal-body pt-0">
            {/* Item Info */}
            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-12">
                 <div className="px-2 py-2" style={{ display: 'flex', gap: '15px',backgroundColor: '#F6F7FC',borderRadius:'4px' }}>
                       <div style={{ flex: 1 }}>
                          <Input label="Supplier" style={{ height: "30px" }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Input label="Purchase Order Id" style={{ height: "30px" }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <Date label="Required By" style={{ height: "30px" }} />
                        </div>
                
                </div>
                <div className="py-2 d-flex">
                       <div style={{ flex: 1 }}>
                          <Button
                            className="createbtn d-flex"
                            style={{ gap: '2px', height: '28px',backgroundColor:'#616A87' }}
                          >
                            Add a Filter&nbsp;<GetIcon iconName="IoFilterSharp" size={12} style={{position:'relative',top:'1.4px'}} />
                          </Button>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="d-flex justify-content-end">
                            <Button
                            className="createbtn d-flex"
                            style={{ gap: '2px', height: '28px',backgroundColor:'#DBDBDB',color:'#1E1E1E' }}
                            >
                           Clear Filters <GetIcon iconName="IoCloseSharp" size={12} style={{position:'relative',top:'1.4px'}} />
                          </Button>
                            </div>
                        </div>               
                </div>
              </div>
            </div>
            <div className="row" style={{ marginBottom: '8px' }}>
              <div className="col-12">
                <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>
                      <input
                      type="checkbox"
                      className="form-check-input"
                      
                    />
                    </th>
                    <th>Purchase Order</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Received Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {data.map((po) => (
                    <tr key={po.name}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selected.includes(po.name)}
                          onChange={() => handleCheckboxChange(po.name)}
                        />
                      </td>
                      <td>{po.name}</td>
                      <td>{po.supplier}</td>
                      <td>{po.transaction_date}</td>
                      <td>{po.company}</td>
                    </tr>
                  ))} */}
                </tbody>
              </table>
              </div>
             
            </div>        
          </div>

          <div className="modal-footer" style={{ borderTop: "none" }}>
            <p style={{ textDecoration: "none", cursor: "pointer" }} className="custom-btn-00989 m-0" >
              Get Items
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditItemModal;
